export const selectTitle = state => {
  return state.meta.title;
};
export const selectDescription = state => {
  return state.meta.description;
};
export const selectKeywords = state => {
  return state.meta.keywords;
};
export const selectImage = state => {
  return state.meta.image;
};
export const selectCanonical = state => {
  return state.meta.canonical;
};
